module.exports = __webpack_public_path__ + "img/0698814.jpg";